class SegmentsDelegate {
    setRows(rows) {
        this.setState((prevState) => {
            return {
                rows,
            };
        });
    }

    setSearch(search) {
        this.setState({ search });
    }

    setSuggestions(suggestions) {
        this.setState({ suggestions });
    }
}

export default SegmentsDelegate;
